import React from "react";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet";

export default function Contact() {
    return (
        <>
        <Helmet>
            <title>Contact | John Mangahis</title>
        </Helmet>
        <div className="main-heading-container">
            <p className="heading-small-caption">Like, comment, *other social media action verbs* !..</p>
            <h1>Contact</h1>
        </div>
        <div className="subheading-container">
            <h2><a className="hover-underline hover-blue" href="mailto:johnrmangahis@icloud.com">Send me an email</a> &#128231; </h2>
        </div>
        <article>
            <p>I strive to be one of those get-rid-of-all-notification-badges type of guy so I'll try my best to get back to you within 24 hours. (Hopefully!)</p>
            <p>Also, if you're into this sort of thing, here's links to my <a href="https://github.com/mangahisjohn"><span className="color-blue hover-underline">GitHub</span></a> and <a href="https://www.linkedin.com/in/john-rafael-mangahis-0049b61b1/"><span className="color-blue hover-underline">LinkedIn</span></a> profiles.</p>
        </article>
        <Footer/>
        </>
    )
}